/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../id_pair';
import '../merchant';
import './tender';
import './cart';
import './refund';
import './square_product_attributes';
import './refund_v3';
import './electronic_signature_details';
import '../../omg/model/orders';
import '../../fiscalreporter/model/invoice_fiscal_data';
import '../options';
import '../date';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "Bill": {
                "fields": {
                  "billIdPair": {
                    "type": ".squareup.client.IdPair",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.client.Merchant",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tender": {
                    "type": ".squareup.client.bills.Tender",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "cart": {
                    "type": ".squareup.client.bills.Cart",
                    "id": 5,
                    "rule": "optional"
                  },
                  "dates": {
                    "type": ".squareup.client.bills.Bill.Dates",
                    "id": 6,
                    "rule": "optional"
                  },
                  "readOnlyRefund": {
                    "type": ".squareup.client.bills.RefundV1",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "squareProductAttributes": {
                    "type": ".squareup.client.bills.SquareProductAttributes",
                    "id": 9,
                    "rule": "optional"
                  },
                  "squareProduct": {
                    "type": ".squareup.client.bills.SquareProduct",
                    "id": 12,
                    "rule": "optional"
                  },
                  "refund": {
                    "type": ".squareup.client.bills.Refund",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "readOnlyElectronicSignatureDetails": {
                    "type": ".squareup.client.bills.ElectronicSignatureDetails",
                    "id": 15,
                    "rule": "optional"
                  },
                  "order": {
                    "type": ".squareup.omg.model.Order",
                    "id": 16,
                    "rule": "optional"
                  },
                  "currentAmendmentClientToken": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "readOnlyLoyaltyDetails": {
                    "type": ".squareup.client.bills.Tender.LoyaltyDetails",
                    "id": 18,
                    "rule": "optional"
                  },
                  "sequentialNumber": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "invoiceFiscalData": {
                    "type": ".squareup.fiscalreporter.model.InvoiceFiscalData",
                    "id": 20,
                    "rule": "optional"
                  },
                  "processingMode": {
                    "type": ".squareup.client.ProcessingMode",
                    "id": 21,
                    "rule": "optional",
                    "options": {
                      "default": "ONLINE"
                    }
                  }
                },
                "nested": {
                  "Dates": {
                    "fields": {
                      "createdAt": {
                        "type": ".squareup.client.ISO8601Date",
                        "id": 1,
                        "rule": "optional"
                      },
                      "completedAt": {
                        "type": ".squareup.client.ISO8601Date",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Bill && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.Bill?.nested?.Dates) {
  $root.addJSON(jsonData);
}

/**
 * A Bill is detailed model about a transaction containing itemizations and tenders.
 *
 * This model is meant to be shared across many different endpoints to enable
 * clients to represent a consistent payment model.
 *
 * SOURCE Bill @ squareup/client/bills/bill.proto at 31:1
 */
export const Bill = $root.lookupType('squareup.client.bills.Bill');
fixType(Bill, {
  billIdPair: {
    required: true
  },
  merchant: {
    required: true
  },
  cart: {
    required: true
  },
  dates: {
    required: true
  }
});
Builder.createAndAttachToType(Bill);
/**
 * SOURCE Dates @ squareup/client/bills/bill.proto at 53:3
 */
Bill.Dates = $root.lookupType('squareup.client.bills.Bill.Dates');
fixType(Bill.Dates, {
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Bill.Dates);